<div class="flex h-full min-h-0 w-full flex-col gap-5 overflow-auto">
	<div>
		<h1 class="text-3xl font-bold">
			<span [translate]>Articles and conversations</span>
		</h1>
		<p class="text-base-content/60 mt-2 text-sm">
			<span [translate]>Manage articles, tickets, backlog items and their conversations from one place.</span>
		</p>
	</div>

	<p class="text-base-content/60 text-sm">
		<span [translate]>Kind, draft publication, public access, featured status and folder membership can be managed independently from the actions menu.</span>
	</p>

	<lib-article-table
		admin-mode="true"
		click-behavior="expand"
		[queryForSearchPatternInUrl]="'adminArticles'"
	>
		<ng-template
			libArticleTableExpanded
			let-article
		>
			<div class="space-y-5 pr-8">
				<article class="bg-base-100 border-base-200 rounded-lg border p-5">
					<div
						class="text-base-content/50 mb-3 text-xs font-semibold uppercase"
						[translate]
					>
						Article
					</div>
					@if (article.summary) {
						<p class="text-base-content/70 mb-4 italic">{{ article.summary }}</p>
					}
					@if (article.content) {
						<div
							class="prose max-w-none"
							[innerHTML]="article.content | sanitizeHtml"
						></div>
					} @else {
						<p
							class="text-base-content/50 text-sm italic"
							[translate]
						>
							No article content.
						</p>
					}
				</article>

				<div class="bg-base-100 border-base-200 rounded-lg border px-4">
					<lib-conversation-displayer
						[resourceId]="article.id"
						[resourceKind]="'article'"
						[conversationKey]="'default'"
						[commentTitle]="('Conversation' | translate | async) ?? 'Conversation'"
						[resourceTitle]="article.title"
						[resourceAuthorId]="article.authorId"
						[adminModeration]="true"
					/>
				</div>
			</div>
		</ng-template>
	</lib-article-table>
</div>
